<template>
    <div class="all">
        <div class="top"></div>
        <div class="left">
            <!-- <img
              class="left-btn left-dangjian"
              :src="dangjian"
              alt
              @click="gopage('2')"
            />-->
            <div class="left-block">
                <div class="left-block-title">
                    <img
                        class="left-block-title-icon"
                        src="../../../assets/images/dataCenterindex/titleIcon.png"
                        alt
                    />
                    <router-link
                        style="color: #fff; text-decoration: none"
                        to="dataCentreindex2"
                    >
                        智慧党建
                    </router-link>
                </div>
                <div class="left-block-activity">
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/dangStudy.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{
                                    activityObj.leave
                                }}</span
                                >次
                            </div>
                            <div class="item-right-desc">党员学习</div>
                        </div>
                    </div>
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/dangCommunity.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{
                                    activityObj.activly
                                }}</span
                                >次
                            </div>
                            <div class="item-right-desc">工作计划</div>
                        </div>
                    </div>
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/dangActivity.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{
                                    activityObj.commun
                                }}</span
                                >次
                            </div>
                            <div class="item-right-desc">党组织活动</div>
                        </div>
                    </div>
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/dangService.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{
                                    activityObj.service
                                }}</span
                                >次
                            </div>
                            <div class="item-right-desc">志愿者服务</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="left-block" style="margin-top: 20px">
                <div class="left-block-title">
                    <img
                        class="left-block-title-icon"
                        src="../../../assets/images/dataCenterindex/titleIcon.png"
                        alt
                    />
                    党组织基本架构
                </div>
                <div class="socialBlock">
                    <div class="socialBlock-left">社区党支部</div>
                    <div class="socialBlock-right">
                        <span class="num">{{ danggongwei }}</span
                        >个
                    </div>
                </div>

                <div class="delta">
                    <img
                        class="delta-img"
                        src="../../../assets/images/dataCenterindex/delta.png"
                    />
                    <div class="delta-text delta-left1">
                        社区党总支
                        <span class="orange">{{ dangzongzhi }}个</span>
                    </div>
                    <div class="delta-text delta-left2">
                        党小组
                        <span class="orange">{{ dangzhibu }}个</span>
                    </div>
                    <div class="delta-text delta-right1">
                        社区党支部
                        <span class="orange">{{ danggongwei }}个</span>
                    </div>
                    <div class="delta-text delta-right2">
                        党员
                        <span class="orange">{{ dangyuan }}个</span>
                    </div>
                </div>
            </div>
            <div class="left-block">
                <div class="left-block-title">
                    <img
                        class="left-block-title-icon"
                        src="../../../assets/images/dataCenterindex/titleIcon.png"
                        alt
                    />
                    人口房屋
                </div>
                <div class="peopAllBox">
                    人口数据
                    <span class="allPeopleNum">{{ rkList.zrk }}</span> 人
                </div>
                <div class="peopleList">
                    <div class="peopLi">
                        <div class="liLeft">
                            <img
                                src="../../../assets/images/bigData/people3.png"
                                alt=""
                            />
                        </div>
                        <div class="liRight">
                            户籍人口
                            <span class="rightNum">{{ rkList.hjr }}</span>
                        </div>
                        <div style="clear: both"></div>
                    </div>
                    <div class="peopLi">
                        <div class="liLeft">
                            <img
                                src="../../../assets/images/bigData/people2.png"
                                alt=""
                            />
                        </div>
                        <div class="liRight">
                            流动人口
                            <span class="rightNum">{{ rkList.ldr }}</span>
                        </div>
                        <div style="clear: both"></div>
                    </div>
                    <div class="peopLi">
                        <div class="liLeft">
                            <img
                                src="../../../assets/images/bigData/people1.png"
                                alt=""
                            />
                        </div>
                        <div class="liRight">
                            出租房屋
                            <span class="rightNum">{{ rkList.ccf }}</span>
                        </div>
                        <div style="clear: both"></div>
                    </div>
                </div>
                <!--        <Echart />-->
            </div>
        </div>
        <div class="mid">
            <div class="mid-top">
                <!--                <bmap @ck="ck" @cks="cks" @setOrgId="setOrgId"></bmap>-->
                <!-- 页面原来的地图 -->
                <!-- <bmap @cks="cks" @setOrgId="setOrgId"></bmap> -->
                <myMap style="width: 103%; height: 120%; position: relative" />
            </div>
            <div class="mid-foot">
                <div class="mid-foot-block">
                    <div class="block-title">
                        <!-- <img class="block-btn" :src="pingan" /> -->
                        <!-- <div class="block-more">更多 >></div> -->
                    </div>
                    <div class="block-title" style>
                        <img
                            class="block-title-icon"
                            src="../../../assets/images/dataCenterindex/titleIcon.png"
                        />
                        <div class="block-title-desc">居民进出数据</div>
                    </div>
                    <div class="table">
                        <div class="table-bar first-tr">
                            <div class="table-item">姓名</div>
                            <div class="table-item td-time">时间</div>
                            <div class="table-item">门号</div>
                        </div>
                        <!-- data.inoutData -->
                        <div
                            class="table-bar"
                            v-for="(item, index) in focusArr"
                            :key="index"
                        >
                            <div class="table-item">{{ item.personName }}</div>
                            <div class="table-item td-time">
                                {{ item.intoTime }}
                            </div>
                            <div class="table-item">{{ item.ipAddress }}</div>
                        </div>
                    </div>
                </div>

                <div class="mid-foot-block" style="margin-top: 5px">
                    <div class="block-title" style>
                        <img
                            class="block-title-icon"
                            src="../../../assets/images/dataCenterindex/titleIcon.png"
                        />
                        <div class="block-title-desc">智慧环保</div>
                    </div>
                    <div class="block-bar">
                        风力：{{ data.weatherData.wind }}
                    </div>
                    <div class="block-bar">
                        PM浓度：{{ data.weatherData.PMnum }}/m3
                    </div>
                    <div class="block-bar">
                        全市实时排名：{{ data.weatherData.rank }}
                    </div>
                    <div class="cloudBar">
                        <div class="cloudItem">
                            <img
                                class="cloudImg"
                                src="../../../assets/images/dataCenterindex/greenCloud.png"
                            />
                            <div class="cloudNum">
                                {{ data.weatherData.min }}
                            </div>
                            <div class="cloudText">优</div>
                        </div>
                        <div class="cloudItem cloudWave">~</div>
                        <div class="cloudItem">
                            <img
                                class="cloudImg"
                                src="../../../assets/images/dataCenterindex/yellowCloud.png"
                            />
                            <div class="cloudNum yellowColor">
                                {{ data.weatherData.max }}
                            </div>
                            <div class="cloudText">良</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="right-weather">
                <img class="weather-img" src="../../../assets/images/yun.png" />
                <div class="right-weather-content">
                    <div class="weather-txt">
                        {{ RemoveChinese(tianqi.low) }}~{{
                            RemoveChinese(tianqi.high)
                        }}{{ tianqi.type }}
                    </div>
                    <div class="weather-time">{{ newTime }}</div>
                </div>
            </div>
            <!-- <img class="right-btn" :src="zhili" @click="gopage('griddingindex')"  alt /> -->
            <div class="right-block">
                <div class="right-block-title flex-bar">
                    <div class="title-left">
                        <img
                            class="right-block-title-icon"
                            src="../../../assets/images/dataCenterindex/titleIcon.png"
                            alt
                        />
                        今日事件数
                    </div>
                </div>
                <div class="case-block">
                    <div
                        class="case-item"
                        v-for="(item, index) in sjList.jr"
                        :key="index"
                    >
                        {{ item }}
                    </div>
                    <div class="case-unit">件</div>
                </div>
                <div class="circle-block">
                    <div class="circle-item">
                        <img
                            class="circle-bg"
                            src="../../../assets/images/dataCenterindex/yuanbg.png"
                        />
                        <img
                            class="circle-wai rotate-speed1"
                            src="../../../assets/images/dataCenterindex/yuanwai.png"
                        />
                        <div class="circle-content">
                            <div class="content-num">{{ sjList.dy }}</div>
                            <div class="content-desc">当月事件数</div>
                            <div class="content-unit">(件)</div>
                        </div>
                    </div>
                    <div class="circle-item">
                        <img
                            class="circle-bg"
                            src="../../../assets/images/dataCenterindex/yuanbg.png"
                        />
                        <img
                            class="circle-wai rotate-speed2"
                            src="../../../assets/images/dataCenterindex/yuanwai.png"
                        />
                        <div class="circle-content">
                            <div class="content-num">{{ sjList.dyja }}</div>
                            <div class="content-desc">当月完结数</div>
                            <div class="content-unit">(件)</div>
                        </div>
                    </div>
                    <div class="circle-item">
                        <img
                            class="circle-bg"
                            src="../../../assets/images/dataCenterindex/yuanbg.png"
                        />
                        <img
                            class="circle-wai rotate-speed3"
                            src="../../../assets/images/dataCenterindex/yuanwai.png"
                        />
                        <div class="circle-content">
                            <div class="content-num">{{ sjList.dywja }}</div>
                            <div class="content-desc">当月未完结</div>
                            <div class="content-unit">(件)</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-block" style="margin-top: -10px">
                <div class="right-block-title flex-bar">
                    <div class="title-left">
                        <img
                            class="right-block-title-icon"
                            src="../../../assets/images/dataCenterindex/titleIcon.png"
                            alt
                        />
                        事件处理
                    </div>
                    <!-- <div class="title-right">更多 >></div> -->
                </div>
                <div class="table">
                    <div class="table-bar first-tr">
                        <div class="table-item">事项编号</div>
                        <div class="table-item">事件来源</div>
                        <div class="table-item">事件描述</div>
                        <div class="table-item">状态</div>
                    </div>
                    <div
                        class="table-bar"
                        v-for="(item, index) in eventList"
                        :key="index"
                    >
                        <div class="table-item">{{ item.eventNumber }}</div>
                        <div class="table-item">{{ item.eventSource }}</div>
                        <div class="table-item">{{ item.eventDescribe }}</div>
                        <div class="table-item">
                            <span v-if="item.approvalStatus == 1">待批转</span>
                            <span v-if="item.approvalStatus == 2">撤销中</span>
                            <span v-if="item.approvalStatus == 3">已撤销</span>
                            <span v-if="item.approvalStatus == 4">已接收</span>
                            <span v-if="item.approvalStatus == 5">结案中</span>
                            <span v-if="item.approvalStatus == 6">延期中</span>
                            <span v-if="item.approvalStatus == 7">退回中</span>
                            <span v-if="item.approvalStatus == 8">作废中</span>
                            <span v-if="item.approvalStatus == 9">已回访</span>
                            <span v-if="item.approvalStatus == 10">已作废</span>
                            <span v-if="item.approvalStatus == 11"
                                >虚拟事件</span
                            >
                            <span v-if="item.approvalStatus == 12"
                                >已审核虚拟</span
                            >
                            <span v-if="item.approvalStatus == 13">待领取</span>
                            <span v-if="item.approvalStatus == 14">已结案</span>
                            <span v-if="item.approvalStatus == 15">已延期</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-block" style="margin-top: 20px">
                <div class="right-block-title flex-bar">
                    <div class="title-left">
                        <img
                            class="right-block-title-icon"
                            src="../../../assets/images/dataCenterindex/titleIcon.png"
                            alt
                        />
                        特殊人群
                    </div>
                </div>
                <div class="special-block">
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/jiao.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{ rkList.sqjz }}</span
                                >人
                            </div>
                            <div class="item-right-desc">社区矫正人员</div>
                        </div>
                    </div>
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/an.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{ rkList.azb }}</span
                                >人
                            </div>
                            <div class="item-right-desc">艾滋病</div>
                        </div>
                    </div>
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/xing.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{ rkList.xmsf }}</span
                                >人
                            </div>
                            <div class="item-right-desc">刑满释放人员</div>
                        </div>
                    </div>
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/du.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{ rkList.xd }}</span
                                >人
                            </div>
                            <div class="item-right-desc">社戒社康</div>
                        </div>
                    </div>
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/fang.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{ rkList.sfry }}</span
                                >人
                            </div>
                            <div class="item-right-desc">重点上访人员</div>
                        </div>
                    </div>
                    <div class="item">
                        <img
                            class="item-icon"
                            src="../../../assets/images/dataCenterindex/bing.png"
                            alt
                        />
                        <div class="item-right">
                            <div class="item-right-num">
                                <span class="number">{{ rkList.jsb }}</span
                                >人
                            </div>
                            <div class="item-right-desc">精神病人</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-block" style="margin-top: -20px">
                <div class="right-block-title flex-bar">
                    <div class="title-left">
                        <img
                            class="right-block-title-icon"
                            src="../../../assets/images/dataCenterindex/titleIcon.png"
                            alt
                        />
                        投诉建议
                    </div>
                    <!-- <div class="title-right">更多 >></div> -->
                </div>
                <div class="table">
                    <div class="table-bar first-tr">
                        <div class="table-item">反馈类别</div>
                        <div class="table-item">对象</div>
                        <div class="table-item">手机号</div>
                        <div class="table-item">状态</div>
                    </div>
                    <div
                        class="table-bar"
                        v-for="(item, index) in complaintsList"
                        :key="index"
                    >
                        <div class="table-item">
                            <span v-if="item.category == 0">投诉</span>
                            <span v-if="item.category == 1">建议</span>
                        </div>
                        <div class="table-item">{{ item.fkName }}</div>
                        <div class="table-item">{{ item.phone }}</div>
                        <div class="table-item">
                            <div
                                v-if="item.status == 0"
                                :style="{ color: '#ff2700' }"
                            >
                                未处理
                            </div>
                            <div
                                v-if="item.status == 1"
                                :style="{ color: '#0f75f2' }"
                            >
                                处理中
                            </div>
                            <div
                                v-if="item.status == 2"
                                :style="{ color: '#fff600' }"
                            >
                                转批中
                            </div>
                            <div
                                v-if="item.status == 3"
                                :style="{ color: '#03c644' }"
                            >
                                已处理
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mapMarkJump" id="mapMarkJump" v-if="win" style>
            <div class="MMJup-box">
                <div class="CJ-box">
                    <s
                        class="marketCloseJump"
                        id="marketCloseJump"
                        @click="closewin"
                    >
                        <i class="el-icon-close" style="color: #fff"></i>
                    </s>
                    <ul class="center-jump-body">
                        <li>事项名称</li>
                        <li>当前环节</li>
                        <li>上报时间</li>
                        <li>状态</li>
                    </ul>
                    <div class="jump-items" id="jumpItemsBoxs">
                        <ul
                            class="jump-item"
                            v-for="(item, index) in cksList"
                            :key="index"
                        >
                            <li>{{ item.eventDescribe }}</li>
                            <li v-if="item.approvalStatus == 1">待批转</li>
                            <li v-if="item.approvalStatus == 2">撤销中</li>
                            <li v-if="item.approvalStatus == 3">已撤销</li>
                            <li v-if="item.approvalStatus == 4">已接收</li>
                            <li v-if="item.approvalStatus == 5">结案中</li>
                            <li v-if="item.approvalStatus == 6">延期中</li>
                            <li v-if="item.approvalStatus == 7">退回中</li>
                            <li v-if="item.approvalStatus == 8">作废中</li>
                            <li v-if="item.approvalStatus == 9">已回访</li>
                            <li v-if="item.approvalStatus == 10">已作废</li>
                            <li v-if="item.approvalStatus == 11">虚拟事件</li>
                            <li v-if="item.approvalStatus == 12">已审核虚拟</li>
                            <li v-if="item.approvalStatus == 13">待领取</li>
                            <li v-if="item.approvalStatus == 14">已结案</li>
                            <li v-if="item.approvalStatus == 15">已延期</li>
                            <li>{{ item.createDate.split(" ")[0] }}</li>
                            <li>
                                <i
                                    v-if="item.approvalStatus == 5"
                                    class="type-event0"
                                    style="background: #e6a23c"
                                ></i>
                                <i
                                    v-if="item.approvalStatus == 6"
                                    class="type-event0"
                                    style="background: #e6a23c"
                                ></i>
                                <i
                                    v-if="item.approvalStatus == 14"
                                    class="type-event0"
                                    style="background: #67c23a"
                                ></i>
                                <i
                                    v-if="item.approvalStatus == 15"
                                    class="type-event0"
                                    style="background: #f56c6c"
                                ></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 四角拐角 -->
                <div class="top-left"></div>
                <div class="top-right"></div>
                <div class="bottom-left"></div>
                <div class="bottom-right"></div>
            </div>
        </div>
    </div>
</template>

<script>
// import CesiumViewer from "@/views/governmentAffairschildren/griddingindexBIg";
import AMap from "AMap" // 引入高德地图
import bmap from "./dataCentreindextest.vue" //页面原来的地图
// import myMap from '@/views/governmentAffairschildren/gridding/griddingindex.vue';
import myMap from "@/views/governmentAffairschildren/gridding/gridsidebarPingAn.vue"
import Echart from "./Echart"
import dataArr from "./data"
import request from "../../../utils/request"
import { getAuthor } from "../../../utils/author"
import { post } from "@/api/requrestHttp"
import axios from "axios"

let infoWindow
export default {
    components: { bmap, Echart, myMap },
    data() {
        return {
            win: false,
            dataArr: dataArr.dataArr,
            data: dataArr.dataArr[0],
            caseNumbers: "012345",
            newTime: "",
            complaintsList: [],
            eventList: [],
            sjList: [],
            rkList: [],
            gridCode: null,
            tianqi: {},
            activityObj: {
                leave: "",
                activly: "",
                commun: "",
                service: "",
            },
            cksList: [],
            dangyuan: "",
            shuliang: "",
            danggongwei: "",
            dangzongzhi: "",
            dangzhibu: "",
            focusArr: [],
        }
    },
    created() {
        // this.creatarr();
    },
    mounted() {
        //  获取当前时间
        let aData = new Date()
        this.newTime =
            aData.getFullYear() +
            "-" +
            (aData.getMonth() + 1) +
            "-" +
            aData.getDate()
        console.log(this.newTime)
        this.getComplaintsList()
        this.getEventList()
        this.getStatistics()
        this.getWthrcdn()
        this.getActivity()
        this.getOrganization()
        this.getResidentData()
    },
    methods: {
        //街道累计活动量
        getActivity() {
            post("/admin/statistics/info/activity", {}).then((res) => {
                if (res.code == 200) {
                    res.content.forEach((item) => {
                        if (item.name == "党员学习") {
                            this.activityObj.leave = item.total
                        }
                        if (item.name == "党组织活动") {
                            this.activityObj.commun = item.total
                        }
                        if (item.name == "工作计划") {
                            this.activityObj.activly = item.total
                        }
                        if (item.name == "志愿者服务") {
                            this.activityObj.service = item.total
                        }
                    })
                    // this.modelTable = res.content
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        //党组织基本架构
        getOrganization() {
            post("/admin/statistics/info/partyOrganization", {}).then((res) => {
                if (res.code == 200) {
                    const that = this
                    res.content.forEach((item) => {
                        if (item.name == "党员") {
                            this.dangyuan = item.total
                        }
                        if (item.name == "党组织数量") {
                            this.shuliang = item.total
                        }
                        if (item.name == "社区党总支") {
                            this.dangzongzhi = item.total
                        }
                        if (item.name == "社区党支部") {
                            this.danggongwei = item.total
                        }
                        if (item.name == "党小组") {
                            this.dangzhibu = item.total
                        }
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        closewin() {
            this.win = false
        },
        cks(e) {
            if (e) {
                console.log(e)
                this.win = true
                post("/admin/statistics/info/findEvent", {
                    pageNo: 1,
                    pageSize: 7,
                    orgId: e,
                }).then((res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.cksList = []
                            res.content.list.forEach((item) => {
                                if (
                                    item.approvalStatus == 5 ||
                                    item.approvalStatus == 6 ||
                                    item.approvalStatus == 14 ||
                                    item.approvalStatus == 15
                                ) {
                                    this.cksList.push(item)
                                }
                            })
                            // this.cksList = res.content.list;
                            // this.complaintsList = res.content;
                        }
                    }
                })
            }
        },
        setOrgId(id) {
            this.gridCode = id
            this.getStatistics()
        },
        // 投诉建议
        getComplaintsList() {
            post("/admin/statistics/info/complaintsList", {}).then((res) => {
                if (res.code == 200) {
                    if (res.content) {
                        this.complaintsList = res.content
                    }
                }
            })
        },
        // 事件列表
        getEventList() {
            post("/admin/statistics/info/eventList", {}).then((res) => {
                if (res.code == 200) {
                    if (res.content) {
                        this.eventList = res.content
                    }
                }
            })
        },
        // 基础数据平台
        getStatistics() {
            post("/admin/statistics/info/statistics", {
                gridCode: this.gridCode,
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content) {
                        let jrList = res.content.sj[0].jr.toString().split("")
                        let l = 6 - (jrList.length % 6)

                        for (let i = 0; i < l; i++) {
                            jrList.unshift("0")
                        }
                        res.content.sj[0].jr = jrList
                        this.sjList = res.content.sj[0]
                        this.rkList = res.content.rk[0]
                        // this.complaintsList = res.content;
                    }
                }
            })
        },
        // 获取天气
        getWthrcdn() {
            // axios.get("http://wthrcdn.etouch.cn/WeatherApi?city=深圳")
            //     .then(function (response) {
            //         console.log(response.data);
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
            post("/admin/statistics/info/tianqi", {}).then((res) => {
                if (res.code == 200) {
                    console.log(res)

                    this.tianqi = res.content.data.forecast[0]
                }
            })
        },
        RemoveChinese(strValue) {
            if (strValue != null && strValue != "") {
                var reg = /[\u4e00-\u9fa5]/g
                return strValue.replace(reg, "")
            } else return ""
        },
        ck(info) {
            //console.log(info);
            if (info == true) {
                this.data = dataArr.dataArr[1]
            } else {
                this.data = dataArr.dataArr[0]
            }
        },
        gopage(e) {
            if (e == "1") {
                location.href = "http://www.huainan.gov.cn/index.html"
            } else if (e == "2") {
                location.href =
                    "http://36.33.216.70:8086/zddj/index.html#g=1&p=%E9%A6%96%E9%A1%B5&c=1"
            } else {
                this.$router.push({ name: e })
            }
        },
        // 居民进出数据
        getResidentData() {
            post("/admin/faceData/info/residentData", {}).then((res) => {
                console.log(res)
                console.log("99999")
                this.focusArr = res.content
            })
        },
    },
}
</script>

<style scoped>
.all {
    width: 100%;
    height: 100%;
    background-image: url("../../../assets/images/dataCenterindex/bg.jpg");
    background-size: 100% 100%;
}

.top {
    width: 40%;
    height: 80px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    /* background-image: url("../../../assets/images/dataCenterindex/top_dsj.png"); */
    /* background-image: url("../../../assets/images/dataCenterindex/tccenter.png"); */
    background-image: url("../../../assets/images/dataCenterindex/top_MG.png");
}

.left {
    float: left;
    width: 25%;
    height: calc(100% - 90px);
}

.mid {
    float: left;
    width: 50%;
    height: calc(100% - 90px);
}

.right {
    float: left;
    width: 25%;
    height: calc(100% - 90px);
}

.mid-top {
    width: 100%;
    height: 75%;
}

.mapMarkJump {
    position: absolute;
    left: 577px;
    bottom: 400px;
    width: 767px;
    height: 397px;
    background: rgba(33, 34, 47, 0.7);
    border: 1px solid #324cb0;
    box-shadow: 0px 0px 18px 2px rgba(21, 213, 241, 0.19);
    z-index: 88888;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mapMarkJump .MMJup-box {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mapMarkJump .MMJup-box .CJ-box {
    position: relative;
    width: 696px;
    height: 326px;
    background: rgba(9, 42, 102, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.top-left,
.top-right,
.bottom-left,
.bottom-right {
    position: absolute;
    width: 22px;
    height: 22px;
}

.top-left {
    top: 0;
    left: 0;
    background: url(../../../assets/images/zuo1_img.png) no-repeat;
}

.top-right {
    top: 0;
    right: 0;
    background: url(../../../assets/images/you1_img.png) no-repeat;
}

.bottom-right {
    bottom: 0;
    right: 0;
    background: url(../../../assets/images/you2_img.png) no-repeat;
}

.bottom-left {
    bottom: 0;
    left: 0;
    background: url(../../../assets/images/zuo2_img.png) no-repeat;
}

.mapMarkJump .MMJup-box .CJ-box s {
    position: absolute;
    cursor: pointer;
    top: -40px;
    right: -40px;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mapMarkJump .MMJup-box .CJ-box .center-jump-body {
    width: 100%;
    height: 42px;
    background: rgba(51, 82, 161, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
}

.mapMarkJump .MMJup-box .CJ-box .center-jump-body li {
    width: 25%;
    height: 100%;
    line-height: 42px;
    text-align: center;
    color: #fff;
}

.mapMarkJump .MMJup-box .CJ-box .jump-items {
    width: 100%;
    height: 210px;
}

.mapMarkJump .MMJup-box .CJ-box .jump-items .jump-item {
    width: 100%;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mapMarkJump .MMJup-box .CJ-box .jump-items .jump-item li:nth-child(1) {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 15px;
    text-overflow: ellipsis;
    color: #fff;
}

.mapMarkJump .MMJup-box .CJ-box .jump-items .jump-item li {
    width: 25% !important;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 42px;
    color: #fff;
    text-align: center;
}

.mapMarkJump .MMJup-box .CJ-box .jump-items .jump-item li .type-event0 {
    background: #a2ff00;
}

.mapMarkJump .MMJup-box .CJ-box .jump-items .jump-item li .type-event1 {
    background: #ffb700;
}

.mapMarkJump .MMJup-box .CJ-box .jump-items .jump-item li i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
}
</style>
<style lang="less" scoped>
@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.animation(@animation-duration,@animation-timing-function) {
    animation: rotate @animation-duration linear @animation-timing-function;
}

.left {
    position: relative;
    top: 0px;

    &-btn {
        width: 330px;
        height: 65px;
        display: block;
        margin-left: 50px;
    }

    &-block {
        width: 100%;
        box-sizing: border-box;
        padding-left: 50px;
        margin-top: 10px;

        &-title {
            display: flex;
            align-items: center;
            width: 100%;
            font-size: 16px;
            color: #fff;

            &-icon {
                width: 15px;
                height: 15px;
                margin-right: 12px;
            }
        }

        &-activity {
            padding-left: 20px;
            width: 100%;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            transform: scale(0.8);

            .item {
                width: 50%;
                display: flex;
                align-items: center;
                margin-top: 20px;

                &-icon {
                    width: 51px;
                    height: 57px;
                    margin-right: 18px;
                }

                &-right {
                    width: calc(100% - 69px);

                    &-num {
                        width: 100%;
                        font-size: 16px;
                        color: #fff;

                        .number {
                            font-size: 36px;
                            font-family: Cybernum;
                        }
                    }

                    &-desc {
                        width: 100%;
                        font-size: 16px;
                        color: #fff;
                    }
                }
            }
        }

        .socialBlock {
            width: 350px;
            margin: 0 auto;
            background: #113379;
            box-sizing: border-box;
            padding: 5px 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 30px;

            &-left {
                font-size: 16px;
                color: #fff;
            }

            &-right {
                color: red;
                font-size: 16px;

                .num {
                    font-size: 28px;
                    font-family: Cybernum;
                }
            }
        }

        .delta {
            width: 342px;
            height: 130px;
            margin: 50px auto;
            position: relative;

            &-img {
                width: 100%;
                /*height: 100%;*/
            }

            &-text {
                position: absolute;
                z-index: 1;
                color: #fff;
                font-size: 16px;

                .orange {
                    color: #f6bd16;
                }
            }

            &-left1 {
                left: 40px;
                top: -20px;
            }

            &-left2 {
                left: 25px;
                top: 30px;
            }

            &-right1 {
                right: 40px;
                top: -5px;
            }

            &-right2 {
                right: 20px;
                top: 40px;
            }
        }
    }
}

.flex-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.right {
    position: relative;

    &-weather {
        width: 100%;
        box-sizing: border-box;
        padding-left: 150px;
        padding-right: 50px;
        position: absolute;
        z-index: 1;
        right: 0;
        top: -50px;
        .flex-bar();

        .weather-img {
            width: 50px;
            height: 30px;
        }

        &-content {
            color: #fff;

            .weather-txt {
                text-align: right;
                font-size: 24px;
            }

            .weather-time {
                font-size: 16px;
                text-align: right;
            }
        }
    }

    &-btn {
        width: 330px;
        height: 65px;
        display: block;
        margin-left: 50px;
    }

    &-block {
        width: 100%;
        box-sizing: border-box;
        padding-left: 50px;
        margin-top: 10px;

        &-title {
            display: flex;
            align-items: center;
            width: 100%;
            font-size: 16px;
            color: #fff;

            &-icon {
                width: 15px;
                height: 15px;
                margin-right: 12px;
            }
        }

        .case-block {
            margin-top: 15px;
            .flex-bar();

            .case-item {
                width: 40px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                color: #2699ff;
                font-weight: 600;
                font-size: 34px;
                background: url("../../../assets/images/dataCenterindex/numberbg.jpg");
                background-size: 100% 100%;
            }

            .case-unit {
                color: #2699ff;
                margin-left: -15px;
                margin-top: 10px;
                font-size: 20px;
            }
        }

        .circle-block {
            .flex-bar();
            margin-top: 0px;
            box-sizing: border-box;
            //justify-content: center;
            height: 140px;
            transform: scale(0.8);

            .circle-item {
                width: 110px;
                height: 110px;
                position: relative;

                .circle-bg {
                    width: 100%;
                    height: 100%;
                }

                .circle-wai {
                    position: absolute;
                    left: -7px;
                    top: -7px;
                    width: 124px;
                    height: 124px;
                    z-index: 1;
                }

                .rotate-speed1 {
                    .animation(15s, infinite);
                }

                .rotate-speed2 {
                    .animation(20s, infinite);
                }

                .rotate-speed3 {
                    .animation(25s, infinite);
                }

                .circle-content {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 2;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .content-num {
                        width: 100%;
                        color: #fff;
                        font-size: 30px;
                        text-align: center;
                    }

                    .content-desc {
                        width: 100%;
                        color: #1b82de;
                        font-size: 16px;
                        text-align: center;
                    }

                    .content-unit {
                        width: 100%;
                        color: #1b82de;
                        font-size: 16px;
                        text-align: center;
                    }
                }
            }

            // .circle-item + .circle-item {
            //   margin-left: 55px;
            // }
        }

        .table {
            width: 380px;
            margin: 0 auto;
            margin-top: 20px;

            &-bar {
                display: flex;
            }

            &-item {
                width: 25%;
                text-align: center;
                line-height: 36px;
                height: 36px;
                font-size: 16px;
                color: #fff;
                box-sizing: border-box;
                border-right: 1px solid #0e3860;
                border-bottom: 1px solid #0e3860;
                display: flex;
                justify-content: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                .table-circle {
                    width: 12px;
                    height: 12px;
                    border-radius: 6px;
                    margin-top: 12px;
                }
            }

            &-item:first-child {
                border-left: 1px solid #0e3860;
            }

            .first-tr {
                background: #0e3860;
            }
        }

        .special-block {
            padding-left: 20px;
            width: 100%;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            transform: scale(0.8);
            margin-top: -25px;

            .item {
                width: 50%;
                display: flex;
                align-items: center;
                margin-top: 20px;

                &-icon {
                    width: 67px;
                    height: 57px;
                    margin-right: 18px;
                }

                &-right {
                    width: calc(100% - 85px);

                    &-num {
                        width: 100%;
                        font-size: 16px;
                        color: #fff;

                        .number {
                            font-size: 28px;
                            font-family: Cybernum;
                            color: #ffab00;
                        }
                    }

                    &-desc {
                        width: 100%;
                        font-size: 16px;
                        color: #fff;
                    }
                }
            }
        }
    }
}

.mid {
    .mid-foot {
        display: flex;

        &-block {
            width: 50%;

            .block-title {
                width: 100%;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                margin-top: 10px;

                .block-btn {
                    width: 330px;
                    height: 65px;
                }

                .block-more {
                    margin-left: 30px;
                    font-size: 16px;
                    color: #fff;
                }

                &-icon {
                    width: 15px;
                    height: 15px;
                    margin-right: 12px;
                }

                &-desc {
                    font-size: 16px;
                    color: #fff;
                }
            }

            .table {
                width: 380px;
                margin: 0 auto;
                margin-top: 20px;

                &-bar {
                    display: flex;
                }

                &-item {
                    width: 25%;
                    text-align: center;
                    line-height: 36px;
                    height: 36px;
                    font-size: 16px;
                    color: #fff;
                    box-sizing: border-box;
                    border-right: 1px solid #0e3860;
                    border-bottom: 1px solid #0e3860;
                    display: flex;
                    justify-content: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    .table-circle {
                        width: 12px;
                        height: 12px;
                        border-radius: 6px;
                        margin-top: 12px;
                    }
                }

                .td-time {
                    width: 50%;
                }

                &-item:first-child {
                    border-left: 1px solid #0e3860;
                }

                .first-tr {
                    background: #0e3860;
                }
            }

            .block-bar {
                font-size: 16px;
                color: #fff;
                font-weight: 600;
                margin-top: 5px;
                width: 100%;
                box-sizing: border-box;
                padding-left: 40px;
            }

            .cloudBar {
                display: flex;
                justify-content: center;
                margin-top: 5px;
                width: 100%;
                transform: scale(0.8);

                .cloudWave {
                    line-height: 80px;
                    font-family: 600;
                    font-size: 28px;
                    text-align: center;
                }

                .cloudItem {
                    width: 82px;
                    height: 80px;
                    position: relative;
                    color: #fff;

                    .cloudImg {
                        width: 82px;
                        height: 50px;
                    }

                    .cloudNum {
                        position: absolute;
                        width: 82px;
                        text-align: center;
                        left: 0;
                        top: 25px;
                        color: #38d82c;
                        z-index: 1;
                        font-weight: 600;
                    }

                    .yellowColor {
                        color: #e8f92a;
                    }

                    .cloudText {
                        margin-top: 0px;
                        width: 100%;
                        text-align: center;
                        color: #fff;
                    }
                }

                .cloudItem + .cloudItem {
                    margin-left: 15px;
                }
            }
        }
    }
}

.peopAllBox {
    color: #ffffff;
    text-align: center;
    line-height: 60px;
}

.peopAllBox .allPeopleNum {
    font-size: 26px;
}

.peopLi {
    margin-top: 10px;
}

.liLeft {
    float: left;
    width: 20%;
    height: 35px;
}

.liLeft img {
    max-height: 35px;
    vertical-align: middle;
}

.liRight {
    float: left;
    width: 80%;
    color: #19e5f6;
    height: 35px;
    line-height: 25px;

    /*border-bottom: 1px solid #ffffff;*/
}

.rightNum {
    font-size: 24px;
    color: #ffffff;
    margin-left: 20px;
}
</style>
